<template>
  <el-row>
    <el-col :span="14">
      <div class="left-container">
        <img src="../../../assets/images/logo.png" alt="积加ERP" class="logo-img"/>
        <img src="../../../assets/images/retrieve-password.png" alt="积加ERP" class="login-bg-img"/>
      </div>
    </el-col>
    <el-col :span="10">
      <div class="right-container">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="login-form">
          <div class="title">找回密码</div>
          <el-form-item class="login-phoneNumber" prop="phoneNumber">
            <el-input
                placeholder="请输入手机号"
                v-model="form.phoneNumber">
              <template slot="prefix">
                <i class="el-input__icon el-icon-mobile-phone"></i>
                <gj-select
                    :clearable="false"
                    :filterable="false"
                    :options="codeOptions"
                    v-model="form.telephoneCode"
                    width="85px"
                ></gj-select>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
              prop="code">
            <el-input
                placeholder="请输入验证码"
                prefix-icon="el-icon-s-claim"
                auto-complete="new-password"
                v-model="form.code">
              <template slot="suffix">
                <gj-button
                    plain
                    type="ghost"
                    size="mini"
                    class="v-code"
                    :disabled="registerCaptchaDisabled"
                    @click="registerCaptcha()">
                  <template v-if="registerCaptchaDisabled">
                    {{registerCaptchaTime}}s后重发
                  </template>
                  <template v-else>
                    获取验证码
                  </template>
                </gj-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
                placeholder="请输入密码"
                type="password"
                prefix-icon="el-icon-lock"
                auto-complete="new-password"
                v-model="form.password">
            </el-input>
          </el-form-item>
          <el-form-item prop="notarize">
            <el-input
                placeholder="请确认密码"
                type="password"
                prefix-icon="el-icon-lock"
                auto-complete="new-password"
                v-model="form.notarize">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
                style="width: 250px;"
                type="primary"
                :loading="loading"
                @click="register()">
              提交
            </el-button>
            <el-row style="text-align: center;">
              <el-button type="text" @click="$router.push({path: '/login'})">
                <span style="color: #999; cursor: text;" @click.stop.prevent>无需重置，</span>去登录
              </el-button>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>

  import {isNotBlank} from "../../../utils/common";
  import {USER_REGISTER} from "../../../store/action-types";
  import {responseMixin} from "../../../minxins";
  import {registerCaptcha, updatePassword, validPhone} from "../../../api/user";
  import {setRegisterInfo} from "../../../utils/auth";
  import { tcAuthCode } from "@/utils/common";
  export default {
    name: "retrieve-password",
    mixins: [responseMixin],
    data() {
      const checkPhoneNumber = (rule, value, callback) => {
        const reg = this.regs[this.form.telephoneCode]
        if (!reg.test(value)) {
          return callback(new Error('手机号码格式不正确'));
        } else {
          return callback();
        }
      };
      const checkPasswords = (rule, value, callback) => {
        if (value !== this.form.password) {
          return callback(new Error('两次输入密码不一致!'));
        } else {
          return callback();
        }
      };
      const checkPassword = (rule, value, callback) => {
        if (isNotBlank(value)) {
          //必须包含字母、数字，可以有（可有可没有）特殊字符  (x20是空格)
          const reg = /^(?=.*\d)(?=.*[A-Za-z])[\x21-\x7e]{6,20}$/;
          // const reg = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,16}$/;
          if (!reg.test(value)) {
            callback(new Error('必须同时包含字母和数字，且长度在6-20位字符之间，区分大小写'));
          }
        }
        callback();
      };
      return {
        form: {
          phoneNumber: null,
          code: null,
          password: null,
          notarize: null,
          userP: false,
          telephoneCode: '86'
        },
        codeOptions: [
          {id: '86', text: '+86(CN)'},
          {id: '1', text: '+1 (US)'},
        ],
        regs: {
          // '86': /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
          '86': /^(\d{10}|\d{11})$/,
          '1': /^(\d{10}|\d{11})$/
        },
        rules: {
          phoneNumber: [
            {required: true, message: '请输入手机号', trigger: ['blur', 'change']},
            {required: true, message: '手机号码格式不正确', validator: checkPhoneNumber, trigger: ['blur']}
          ],
          code: [
            {required: true, message: '请输入验证码', trigger: ['blur', 'change']}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: ['blur', 'change']},
            // {min: 6, max: 20, message: '限制6-20个字符', trigger: ['blur', 'change']},
            {validator: checkPassword, trigger: ["blur", "change"]}
          ],
          notarize: [
            {required: true, message: '请确认密码', trigger: ['blur', 'change']},
            {required: true, message: '两次输入密码不一致!', validator: checkPasswords, trigger: ['blur', 'change']}
          ],
        },
        registerCaptchaDisabled: false,
        registerCaptchaTime: null,
        formValid: true,
        loading: false
      }
    },
    methods: {
      registerCaptcha() {
        this.$refs.form.validateField('phoneNumber', err => {
          if (err) { // 手机号码校验不通过
            return;
          }
          // 腾讯图形验证码
          tcAuthCode(this.form.phoneNumber).then(resolve => {
            // 验证完成
            if (!err) {
              validPhone({mobile: this.form.phoneNumber, code:resolve}, this.form.telephoneCode)
                .then((res) => {
                  this.$gjResponseHandle(
                    res,
                    () => {
                      this.registerCaptchaDisabled = true;
                      this.registerCaptchaTime = 120;
                      const intervalHandle = setInterval(() => {
                        if (this.registerCaptchaTime > 0) {
                          this.registerCaptchaTime--;
                        } else {
                          this.registerCaptchaDisabled = false;
                          clearInterval(intervalHandle);
                        }
                      }, 1000);
                    },
                  )
                });
            }
          }).catch(error => {
            // 未验证
          });
        });
      },
      register() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.loading = true;
            updatePassword(this.form.code, this.form.phoneNumber, this.form.password, this.form.telephoneCode)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('修改成功');
                  setRegisterInfo({phone: this.form.phoneNumber});
                  this.$router.replace('/login');
                })
              }).complete(() => this.loading = false)
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .left-container,
  .right-container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-container {
    background-color: #f3f9ff;
  }

  .logo-img {
    width: 234px;
    position: absolute;
    top: 40px;
    left: 65px;
  }

  .login-bg-img {
    width: 70%;
  }

  /deep/ .login-form {
    width: 50%;
    min-width: 400px;
    text-align: center;
  }

  /deep/ .login-form .title {
    margin-bottom: 20px;
    font-size: 22px;
    color: #64a0ff;
  }

  /deep/ .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-radius: 0;
  }

  /deep/ .el-input__prefix {
    left: 0;
    font-size: 18px;
  }

  /deep/ .el-form-item {
    margin-bottom: 24px;
  }

  /deep/ .el-checkbox__label {
    color: #999;
  }

  /deep/ .el-checkbox__label:hover,
  /deep/ .el-checkbox__label:focus {
    color: #66b1ff;
  }
  .login-phoneNumber{
    &/deep/.el-input__inner{
      padding-left: 110px;
    }
    &/deep/.el-input__prefix{
      display: flex;
      align-items: center;
    }
    &/deep/ .el-select__caret{
      color: #333333;
      font-weight: bold;
    }
    &/deep/.gj-select{
      .el-input__inner{
        padding: 0 0 0 5px;
        border: none;
        font-size: 13px;
      }
    }
  }
</style>
